import vClickOutside from 'v-click-outside'

import { icArrowSmallUp, icArrowSmallDown } from '@vivareal/lina-icons'

import ozIconRemoveFilter from '@/pages/results/components/filters/oz-icon-remove-filter'

export default {
  name: 'oz-amount',

  props: {
    model: { type: String, required: true },
    title: { type: String, required: true },
    filters: { type: Object, required: true },
    singularTitle: { type: String, required: true },
    isPill: { type: Boolean },
    options: {
      type: Array,
      default () {
        return Array.from({ length: 4 }, (_, index) => {
          const value = (index + 1).toString()
          const label = value === '4' ? '4+' : value
          return { label, value }
        })
      },
    },
  },

  data () {
    return {
      open: false,
      selectedOptions: [],
    }
  },

  created () {
    this.setTitle()

    if (this.filters[this.model]) this.selectedOptions = (this.filters[this.model]).toString().split(',')
  },

  watch: {
    filters () {
      const model = this.filters[this.model]

      if (model && model !== 0 && model !== '') this.selectedOptions = (model).toString().split(',')
      else this.selectedOptions = []
    },
  },

  computed: {
    titleColor () {
      return ((this.open || this.selectedOptions.length)) ? 'primary' : 'dark'
    },

    iconColor () {
      return this.open ? 'primary' : 'dark'
    },

    icon () {
      return this.open ? icArrowSmallUp : icArrowSmallDown
    },

    amountTitle () {
      let title = this.setTitle()

      if (title === '4 ou mais') title += ` ${this.title}`
      return title
    },
  },

  methods: {
    toggleOptions () {
      this.open = !this.open
      if (!this.open) this.setTitle()
    },

    closeOptions () {
      if (this.open) {
        this.open = false
        this.setTitle()
      }
    },

    selectOption (option) {
      const { value } = option
      const hasValue = this.isSelected(value)

      if (!this.selectedOptions.length || !hasValue) {
        this.selectedOptions.push(value)
      }

      if (hasValue) {
        const valueIndex = this.selectedOptions.indexOf(value)
        this.selectedOptions.splice(valueIndex, 1)
      }

      this.filterAmount()
    },

    filterAmount () {
      const selectedOptions = this.selectedOptions.toString()
      this.$emit('filters:update', { [this.model]: selectedOptions })
    },

    removeFilter () {
      this.selectedOptions = []
      this.$emit('filters:update', { [this.model]: '' }, this.model)
    },

    setTitle () {
      const selectedOptsLength = this.selectedOptions.length

      if (selectedOptsLength > 1) {
        return `${this.selectedOptions.sort().join(', ').replace(/(.*), (.*)/, '$1 ou $2')} ${this.singularTitle}s`
      }

      if (selectedOptsLength === 1) {
        const onlyOption = this.selectedOptions[0]

        if (onlyOption === '1') return `${onlyOption} ${this.singularTitle}`
        if (onlyOption === '4') return `${onlyOption} ou mais`
        return `${onlyOption} ${this.singularTitle}s`
      }

      return `${this.title}`
    },

    isSelected (value) {
      return this.selectedOptions.includes(value)
    },
  },

  directives: {
    clickOutside: vClickOutside.directive,
  },

  components: { ozIconRemoveFilter },
}
